module.exports = __webpack_public_path__ + "img/mazda-Used.e385bf63.png";